module.exports = __webpack_public_path__ + "static/logo-dark@2x-1c6b3ba3fad388aa06f0e967c2cb2059.png";